import MainPage from "./MainPage";
import Dashboard from "./MainPage/Dashboard";
import Operation from "./MainPage/Operation";
import Report from "./MainPage/Report";
import List from "./MainPage/List";
import SettingPage from "./MainPage/Setting/SettingPage";
import NotFoundPage from "./NotFoundPage";
import { Navigate, BrowserRouter as Router, Route, Routes, } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Table from "../Components/Table/Table";
import Chart from "../Components/Chart";
import { ToastContainer } from "react-toastify";
import Factorprint from "../Components/Printpage/Factorprint";
import Assistant from "./AssistantPage";
import Bill from "../Components/Assistant/Bill/Bill";
import Category from "../Components/Assistant/Category/Category";
import AddNewReport from "../Components/Assistant/ReportAssistant/AddNewReport/AddNewReport";
import DashboardAssistant from "../Components/Assistant/Dashboard/DashboardAssistant";
import DocumentForm from "../Components/Assistant/DocumentForm";
import MainFormBuilder from "../Components/Assistant/MainFormMaker/MainFormBuilder";
import LevelForm from "../Components/Assistant/LevelForm/LevelForm";
import DeleteLevelForm from "../Components/Assistant/DeleteLevelForm/DeleteLevelForm";
import ReportAssistant from "../Components/Assistant/ReportAssistant/ReportAssistant";
import Form from "../Components/Form";
import FormKpiView from "../Components/Form/FormKpiView";
import FormKpiBuilderNew from "../Components/Form/FormKpiBuilderNew";
import AdminReport from "../Components/AdminReport/AdminReport";
import GroupPhaseOrders from "../Components/Phase/GroupPhaseOrders/GroupPhaseOrders";
import AdminDashboardSettings from "../Components/Setting/AdminDashboardSettings/AdminDashboardSettings";
import ReportBuilder from "../Components/Report/ReportBuilder/ReportBuilder";
import ReportShow from "../Components/Report/ShowReport/ReportShow";
import NewDataChart from "../Components/Report/NewDataChart/NewDataChart";
import Download from "../Components/Download/Download";
import SubmitDocumentForm from "../Components/AccountingCoding/SubmitDocumentForm/SubmitDocumentForm";
import ViewDocuments from "../Components/AccountingCoding/ViewDocuments/ViewDocuments";
import CostAndBenefit from "../Components/AccountingCoding/CostAndBenefit/CostAndBenefit";
import SellFactor from "../Components/SellFactor/SellFactor";
import AddMultiProduct from "../Components/AddMultiProduct/AddMultiProduct";
import TransferBetweenStores from "../Components/TransferBetweenStores/TransferBetweenStores";
import SaleReturn from "../Components/SaleReturn/SaleReturn";
import BuyReturn from "../Components/BuyReturn/BuyReturn";
import ObjectDataHolder from "../Components/Hooks/ObjectDataHolder";
import Printer from "../Components/Printer/Printer";
import GeneralLedger from "../Components/AccountingCoding/Ledger/GeneralLedger";
import Journal from "../Components/AccountingCoding/Ledger/Journal";
import LedgerTable from "../Components/AccountingCoding/Ledger/LedgerTable";
import TableDetailCoding from "../Components/AccountingCoding/DetailedTable/TableDetailCoding/TableDetailCoding";
import FactorNEW from "../Components/Factor/FactorNEW";
import CarWashingFactor from "../Components/AccountingCarWash/CarWashingFactor/CarWashingFactor";
import SettingPagePermissionOptions from "../Components/Setting/Permissions/SettingPagePermissionOptions";
import FollowUpList from "../Components/FollowUpPage/FollowUpList";
import AutoC from "../Components/autoc/AutoC";
import AddProduct from "../Components/AddProduct/AddProduct";
import FormAtelier from "../Components/NewAtelierForm/FormFactor";
import SmsPanel from "../Components/SmsPanel/SmsPanel";
import CounterFactor from '../Components/CounterFactor/CounterFactor';
import BuyMaterialFactorPO from "../Components/PrintingOfficeFactor/BuyMaterialFactorPO/BuyMaterialFactorPO";
import FormInstitutes from "../Components/LanguageInstitutes/FormInstitutes";
import ReturnedGoodsFactor from '../Components/ReturnedGoodsFactor/ReturnedGoodsFactor';
import CardLearner from "../Components/LanguageInstitutes/CardLearner";
import SellFactorSadan from "../Components/SellFactorSdanaShop/SellFactorSadan";
import BuyFactorSadan from "../Components/BuyFactorSadan";
import ReviewAccounts from "../Components/ReviewAccounts";
import CardexProductSadanShopTypeTwo
  from "../Components/CardexSadanShop/CardexProductSadanShop/CardexProductSadanShopTypeTwo";
import BuyReturnSadan from "../Components/BuyReturnSadan/BuyReturnSadan";
import SaleReturnSadan from "../Components/SaleReturnSadan/SaleReturnSadan";
import TransferBetweenStoresSadan from "../Components/TransferBetweenStoresSadan/TransferBetweenStoresSadan";
import CostAndBenefit2 from "../Components/AccountingCoding/CostAndBenefit2/CostAndBenefit2";
import BalanceSheet2 from "../Components/AccountingCoding/BalanceSheet2/BalanceSheet2";
import NoteBookReport from "../Components/AccountingCoding/NoteBookReport/NoteBookReport";
import SellSclFactor from "../Components/SellSclFactor/SellSclFactor";
import InvoiceStatementSadanShop from "../Components/InvoiceStatement/index"
import TableOrderView from "../Components/TableOrderView/TableOrderView";
import OrdersSadan from "../Components/OrdersSadan/OrdersSadan";
import Insurance from "../Components/Insurance/Insurance";
import MainBuyFactor from "../Components/A13/BuyFactor/MainBuyFactor";
import TextEditor from "../Components/A13/DynaView/TextEditor/TextEditor";
import MainInsuranceForm from "../Components/A13/InsuranceFormCompomemts/MainInsuranceForm";
import TransferLearner from "../Components/A13/LanguageLearner/TransferLearner/TransferLearner";
import ReceiveCustomerInstallments
  from "../Components/A13/InsurancePages/ReceiveCustomerInstallments/ReceiveCustomerInstallments";
import PaymentOfInstallments from "../Components/A13/InsurancePages/PaymentOfInstallments/PaymentOfInstallments";
import BalanceSheet from "../Components/A13/AccountingPages/BalanceSheet/BalanceSheet";
import ProfitReport from "../Components/A13/AccountingPages/ProfitReport/ProfitReport";
import AdvertisingCampaign from "../Components/A13/AdvertisingCampaign/AdvertisingCampaign";
import DocumentIssuance from "../Components/A13/AccountingPages/DocumentIssuance/DocumentIssuance";
import LoginPage from "./LoginPage";
import ImportDocumentIssuance from "../Components/A13/AccountingPages/ImportDocumentIssuance/ImportDocumentIssuance";
import AdminSupervision from "../Components/A13/SupervisionPages/AdminSupervision/AdminSupervision";
import ProgrammerSupervision from "../Components/A13/SupervisionPages/AdminSupervision/ProgrammerSupervision";
import InsuranceAgentForm from "../Components/A13/InsurancePages/InsuranceAgentForm/InsuranceAgentForm";
import NewOrderForm from "../Components/A13/HiSite/NewOrderForm/NewOrderForm";
import LeadAllocation from "../Components/A13/HiSite/LeadAllocation/LeadAllocation";
import NewPermissions from "../Components/Setting/Permissions/NewPermissions/NewPermissions";
import LeadManage from "../Components/A13/HiSite/LeadManage/LeadManage";
import InsuranceOverallReport from "../Components/A13/InsurancePages/InsuranceOverallReport/InsuranceOverallReport";
import DailyInsurance from "../Components/A13/InsurancePages/DailyInsurance/DailyInsurance";
import DailyCompanyInstallments from "../Components/A13/InsurancePages/DailyCompanyInstallments/DailyCompanyInstallments";
import DailyCustomerInstallments from "../Components/A13/InsurancePages/DailyCustomerInstallments/DailyCustomerInstallments";
import MarketersShare from "../Components/A13/InsurancePages/MarketersShare/MarketersShare";
import InsurancePrint from "../Components/A13/InsurancePages/InsurancePrint/InsurancePrint";
import UsersDailyInstallments from "../Components/A13/InsurancePages/UsersDailyInstallments/UsersDailyInstallments";
import ProductValuation from "../Components/Chika/ChikaPages/ProductValuation/ProductValuation";
import ProductEntry from "../Components/Chika/ChikaPages/ProductEntry/ProductEntry";
import ProductFormula from "../Components/Chika/ChikaPages/ProductFormula/ProductFormula";
import UnenteredInsurance from "../Components/A13/InsurancePages/UnenteredInsurance/UnenteredInsurance";
import OrderReport from "../Components/Chika/ChikaPages/OrderReport/OrderReport";
import AddEditOrder from "../Components/Chika/ChikaPages/AddEditOrder/AddEditOrder";
import AddEditCustomer from "../Components/Chika/ChikaPages/AddEditCustomer/AddEditCustomer";
import AddEditDriver from "../Components/Chika/ChikaPages/AddEditDriver/AddEditDriver";

export const PrintDataContext = React.createContext();
export const SetPrintDataContext = React.createContext();
export const SharedContext = React.createContext();

export default function Pages() {
  const [isAuth, setIsAuth] = useState(
    sessionStorage.getItem("isAuth") === "true"
  );

  const [factorData, setFactorData] = useState(0);
  useEffect(() => {
    sessionStorage.setItem("isAuth", isAuth);
  }, [isAuth]);
  const [state, setState] = ObjectDataHolder({ type: "", data: "" });
  return (
    <Router>
      <ToastContainer
        position="bottom-left"
        autoClose={2500}
        hideProgressBar={true}
        newestOnTop={false}
        theme="colored"
        closeOnClick
        rtl
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
      />
      <SetPrintDataContext.Provider value={setFactorData}>
        <PrintDataContext.Provider value={factorData}>
          <SharedContext.Provider value={{ state, setState }}>
            <Routes>
              <Route exact path="/" element={isAuth ?
                (<MainPage setIsAuth={setIsAuth} sidebarMode={"normal"} />) :
                (<Navigate to={"/Login"} />)}>

                {/*A13Folder*/}
                <Route path="MainBuyFactor" element={<MainBuyFactor />} />
                <Route path="text-editor" element={<TextEditor />} />

                {/*Bime*/}
                <Route path="/InsuranceForm" element={<MainInsuranceForm />} />
                <Route path="/ReceiveCustomerInstallments" element={<ReceiveCustomerInstallments />} />
                <Route path="/PaymentOfInstallments" element={<PaymentOfInstallments />} />
                <Route path="/insurance-agent-form" element={<InsuranceAgentForm />} />

                <Route path={"/transfer-learner"} element={<TransferLearner />} />
                <Route path={"/insurance-overall-report"} element={<InsuranceOverallReport />} />
                <Route path={"/daily-insurance"} element={<DailyInsurance />} />
                <Route path={"/daily-company-installments"} element={<DailyCompanyInstallments />} />
                <Route path={"/daily-customer-installments"} element={<DailyCustomerInstallments />} />
                <Route path={"/marketers-share"} element={<MarketersShare />} />
                <Route path={"/users-daily-installments"} element={<UsersDailyInstallments />} />
                <Route path={"/unentered-insurance"} element={<UnenteredInsurance />} />
                {/*Insurance Print  */}
                <Route path={"/insurance-print"} element={<InsurancePrint />} />

                {/*Chika*/}
                <Route path={"/product-valuation"} element={<ProductValuation />} />
                <Route path={"/product-entry"} element={<ProductEntry />} />
                <Route path={"/product-formula"} element={<ProductFormula />} />
                <Route path={"/order-report"} element={<OrderReport />} />
                <Route path={"/add-edit-order"} element={<AddEditOrder />} />
                <Route path={"/add-edit-customer"} element={<AddEditCustomer />} />
                <Route path={"/add-edit-driver"} element={<AddEditDriver />} />

                {/*Accounting*/}
                <Route path={"/coding/BalanceSheet"} element={<BalanceSheet />} />
                <Route path={"/coding/ProfitReport"} element={<ProfitReport />} />
                <Route path={"/coding/DocumentIssuance"} element={<DocumentIssuance />} />
                <Route path={"/coding/ImportDocumentIssuance"} element={<ImportDocumentIssuance />} />

                <Route path={"/advertising-campaign"} element={<AdvertisingCampaign />} />

                <Route path={"/admin-supervision"} element={<AdminSupervision />} />
                <Route path={"/programmer-supervision"} element={<ProgrammerSupervision />} />

                {/*HiSire*/}
                <Route path={"/new-order-form"} element={<NewOrderForm />} />
                <Route path={"/lead-allocation"} element={<LeadAllocation />} />
                <Route path={"/lead-manage"} element={<LeadManage />} />

                {/*/!*Setting*!/*/}
                {/*<Route path={"/Setting/userPermission2"} element={<NewPermissions/>}/>*/}

                {/*A13Folder*/}

                {/* orderView Anipo  */}
                <Route path="insuranceir" element={<Insurance />} />
                {/* orderView Anipo  */}
                <Route path="OrdersSadan" element={<OrdersSadan />} />
                {/* orderView Anipo  */}
                <Route path="TableOrderView" element={<TableOrderView />} />
                {/* InvoiceStatementSadanShop sadan  */}
                <Route path="InvoiceStatementSadanShop" element={<InvoiceStatementSadanShop />} />
                {/* sellfactorscl sadan  */}
                <Route path="sellfactorscl" element={<SellSclFactor />} />
                {/* storeRemittanceSadan sadan  */}
                <Route path="storeRemittanceSadan" element={<TransferBetweenStoresSadan />} />
                {/* sellreturn sadan  */}
                <Route path="SaleReturnSadan" element={<SaleReturnSadan />} />
                {/* BuyReturnSadan */}
                <Route path="BuyReturnSadan" element={<BuyReturnSadan />} />
                {/* ReviewAccounts */}
                <Route path="ReviewAccounts" element={<ReviewAccounts />} />
                {/* ReturnedGoodsFactor */}
                <Route path="buyFactorSadan" element={<BuyFactorSadan />} />
                {/* ReturnedGoodsFactor */}
                <Route path="SellFactorSadan" element={<SellFactorSadan />} />
                {/* ReturnedGoodsFactor */}
                <Route path="ReturnedGoodsFactor" element={<ReturnedGoodsFactor />} />
                {/* CounterFactor */}
                <Route path="CounterFactor" element={<CounterFactor />} />
                {/* FormAtelier */}
                <Route path="FormAtelier" element={<FormAtelier />} />
                {/* FormInstitutes */}
                <Route path="/FormInstitutes" element={<FormInstitutes />} />
                {/* CardLearner */}
                <Route path="CardLearner" element={<CardLearner />} />
                {/* addProduct */}
                <Route path="addProduct" element={<AddProduct />} />
                {/* Map */}
                <Route path="map" element={<AutoC />} />
                {/* Printer */}
                <Route path="printer" element={<Printer />} />
                {/* cardexProduct */}
                <Route path="cardexProduct" element={<CardexProductSadanShopTypeTwo />} />
                {/* buy Return  */}
                <Route path="buyReturn" element={<BuyReturn />} />
                {/* TransferBetweenStores  */}
                <Route path="saleReturn" element={<SaleReturn />} />
                {/* TransferBetweenStores  */}
                <Route path="storeRemittance" element={<TransferBetweenStores />} />

                <Route path="BuyMaterialFactorPO" element={<BuyMaterialFactorPO />} />
                {/* addMultiProduct  */}
                <Route path="addMultiProduct" element={<AddMultiProduct />} />
                {/* buy Factor */}
                <Route path="buyFactor" element={<FactorNEW type={"buy"} />} />
                {/* carWash Factor */}
                <Route path="sellFactor" element={<SellFactor />} />
                {/* carWash Factor */}
                <Route path="carWashFactor" element={<CarWashingFactor />} />
                {/* codings Routes */}

                {/*FollowUp System*/}
                <Route path="FollowUpList" element={<FollowUpList />} />

                <Route path="/coding/submitDocumentForm" element={<SubmitDocumentForm />} />

                <Route path={"/coding/viewDocuments"} element={<ViewDocuments />} />

                <Route path={"/coding/detailedTable"} element={<TableDetailCoding />} />

                <Route path={"/coding/noteBookReport"} element={<NoteBookReport />} />

                <Route path={"/coding/BalanceSheet2"} element={<BalanceSheet2 />} />

                <Route path={"/coding/positionStatement"} element={<CostAndBenefit />} />

                <Route path={"/coding/costAndBenefit2"} element={<CostAndBenefit2 />} />

                <Route path={"/coding/constAndBenefit"} element={<CostAndBenefit />} />

                <Route path={"/coding/journal"} element={<Journal />} />

                <Route path={"/coding/generalLedger"} element={<GeneralLedger />} />

                <Route path={"/coding/LedgerTable"} element={<LedgerTable />} />
                {/* End Of codings Routes */}
                <Route
                  path="define-new-data-chart"
                  element={<NewDataChart />}
                />
                <Route path="showDashboardSettings" element={<ReportShow />} />
                <Route
                  path="defineDashboardSettings"
                  element={<ReportBuilder />}
                />
                <Route
                  path="AdminDashboardSettings"
                  element={<AdminDashboardSettings />}
                />
                <Route path="/factorprint" element={<Factorprint />} />
                <Route path="/download" element={<Download />} />
                <Route path="/adminReport" element={<AdminReport />} />
                <Route path="phaseOptions" element={<GroupPhaseOrders />} />
                <Route path="Dashboard" element={<Dashboard />} />
                <Route path="openKpiPage" element={<FormKpiView />} />
                {/* <Route path="FormKpiBuilder" element={<FormKpiBuilder />} /> */}
                <Route path="FormKpiBuilder" element={<FormKpiBuilderNew />} />
                <Route path="Operation/:id" element={<Operation />} />
                <Route path="Report" element={<Report />}>
                  <Route path=":id" element={<Chart />} />
                </Route>

                <Route path="List" element={<List />}>
                  <Route path=":id" element={<Table />} />
                </Route>
                <Route path="send-sms" element={<SmsPanel />} />
                <Route path="Setting" element={<SettingPage />} />
                <Route
                  path="Setting/userPermission"
                  element={<SettingPagePermissionOptions />}
                />
                <Route path="/" element={<Dashboard />} />

              </Route>

              <Route path="/assistant" element={isAuth ? (
                <Assistant setIsAuth={setIsAuth} />) : (
                <Navigate to={"/Login"} />)}>

                <Route path="category" element={<Category />}>
                  <Route path=":id/:level/:code" element={<Category />} />
                </Route>
                <Route path="report" element={<AddNewReport />} />
                <Route path="report/:id" element={<ReportAssistant />} />
                <Route path="addNewReport/:id" element={<AddNewReport />} />
                <Route path="document-form" element={<DocumentForm />} />
                <Route path="new-form/:id" element={<MainFormBuilder />} />
                <Route path="AssistantForm/:id" element={<Form />} />
                <Route path="level-form" element={<LevelForm />} />
                <Route path="bill" element={<Bill />} />
                <Route path="delete-level" element={<DeleteLevelForm />} />
                <Route path="dashboardAssistant" element={<DashboardAssistant />} />
              </Route>

              <Route path="/Login" element={isAuth ? (
                <Navigate to={"/Dashboard"} />) : (
                <LoginPage isAuthenticated={[isAuth, setIsAuth]} />
              )} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </SharedContext.Provider>
        </PrintDataContext.Provider>
      </SetPrintDataContext.Provider>
    </Router>
  );
}
